var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"waterjetBedContainer",staticClass:"waterjet-bed"},[_c('canvas',{ref:"waterjetCanvas",on:{"click":_vm.canvasClicked}})])}
var staticRenderFns = []

export { render, staticRenderFns }